import { RouteNames } from '../../types/RouteNames'

const withAdminBaseRoute = <T extends string>(path: T) =>
  `/clinic${path}` as const

export const adminDynamicRoutes = {
  profileInfo: <T extends string>(idClient: T) =>
    withAdminBaseRoute(`/profile-info/${idClient}`),
  responsiblesWithPersona: <T extends string>(personaName: T) =>
    withAdminBaseRoute(`/responsibles?personaName=${personaName}`),
  therapistsWithPersona: <T extends string>(personaName: T) =>
    withAdminBaseRoute(`/therapists?personaName=${personaName}`),
  operationalWithPersona: <T extends string>(personaName: T) =>
    withAdminBaseRoute(`/operational?personaName=${personaName}`),
  gallery: <T extends string>(patientId: T) =>
    withAdminBaseRoute(`/patient/${patientId}/gallery`),
  galleryItem: <T extends string>(patientId: T) =>
    withAdminBaseRoute(`/patient/${patientId}/gallery/:id`),
  galleryFolder: <T extends string>(patientId: T) =>
    withAdminBaseRoute(`/patient/${patientId}/folder/:id`)
}

export const adminRouteNames = {
  home: withAdminBaseRoute(''),
  fileEditor: withAdminBaseRoute('/fileEditor'),
  profile: withAdminBaseRoute('/profile'),
  dashboard: withAdminBaseRoute('/dashboard'),
  automations: withAdminBaseRoute('/automations'),
  clinic: withAdminBaseRoute('/clinic'),
  users: withAdminBaseRoute('/users'),
  configurations: withAdminBaseRoute('/configurations'),
  patients: withAdminBaseRoute('/patients'),
  admins: withAdminBaseRoute('/admins'),
  therapists: withAdminBaseRoute('/therapists'),
  responsibles: withAdminBaseRoute('/responsibles'),
  operational: withAdminBaseRoute('/operational'),
  tasksChecklist: withAdminBaseRoute('/tasks-checklist'),
  tags: withAdminBaseRoute('/tags'),
  usersGroups: withAdminBaseRoute('/group-users'),
  groupDetails: withAdminBaseRoute('/group-details/:id'),
  liquids: withAdminBaseRoute('/liquids'),
  belongs: withAdminBaseRoute('/belongs'),
  remedies: withAdminBaseRoute('/remedies'),
  integrations: withAdminBaseRoute('/integrations'),
  integrationStatus: withAdminBaseRoute('/integrationStatus'),
  templateArquive: withAdminBaseRoute('/template-arquive'),
  listGroupFeed: withAdminBaseRoute('/list-group-feed'),
  company: withAdminBaseRoute('/company'),
  tickets: withAdminBaseRoute('/tickets'),
  documents: withAdminBaseRoute('/documents'),
  managementSessions: withAdminBaseRoute('/management-sessions'),
  profileInfo: adminDynamicRoutes.profileInfo(':idClient'),
  gallery: adminDynamicRoutes.gallery(':patientId'),
  galleryItem: adminDynamicRoutes.galleryItem(':patientId'),
  galleryFolder: adminDynamicRoutes.galleryFolder(':patientId')
} as const satisfies RouteNames
